import { ThumbnailPreview } from "./ThumbnailPreview";

export * from "./ThumbnailPreview";
export default ThumbnailPreview;
